import { InternalStorageGate } from "./internalStorage.types";

export const INTERNAL_STORAGE_GATE_CONFIG: Record<
  InternalStorageGate,
  {
    gateIdKey: "farmGateId" | "processGateId";
    deleteTitle: string;
    deleteSubtitle: string;
  }
> = {
  farm: {
    gateIdKey: "farmGateId",
    deleteTitle: "Delete Farm Gate Internal Storage",
    deleteSubtitle:
      "Are you sure you want to remove the farm gate internal storage? Please consider you cannot recover these data after removed"
  },
  process: {
    gateIdKey: "processGateId",
    deleteTitle: "Delete Process Gate Internal Storage",
    deleteSubtitle:
      "Are you sure you want to remove the process gate internal storage? Please consider you cannot recover these data after removed"
  }
};

export const getInternalStorageGateConfig = (gate: InternalStorageGate) =>
  INTERNAL_STORAGE_GATE_CONFIG[gate];
